module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/carousel_tiktok_tablet_05@2x-cc31d3f06de586668186ed474dc0ad3e.jpg";